import { zodResolver } from "@hookform/resolvers/zod";
import Input from "components/Input";
import PublicPage from "components/PublicPage";
import Textarea from "components/Textarea";
import React from "react";
import { useForm, useFormState } from "react-hook-form";
import { toast } from "react-toastify";
import { api } from "utils/api";
import { EMAILS } from "utils/constants";
import { sendContactMessageSchema } from "utils/schemas";
import { z } from "zod";

type Data = z.infer<typeof sendContactMessageSchema>;

export default function ContactPage() {
  const { register, control, handleSubmit, reset } = useForm<Data>({
    resolver: zodResolver(sendContactMessageSchema),
  });
  const { errors } = useFormState({ control });

  const mutation = api.emails.sendContactMessage.useMutation({
    onSuccess: () => {
      toast.success("Message sent!");
      reset();
    },
    onError: (err) => {
      console.error(err);
      toast.error("Error sending message.");
    },
  });

  const onSubmit = async (data: Data) => {
    await mutation.mutateAsync(data);
  };

  return (
    <PublicPage
      metadata={{
        title: "Contact Pipers For Hire",
        description: "Contact Pipers For Hire",
        url: "https://pipersforhire.com/contact",
      }}
    >
      <h1 className="text-2xl font-bold text-theme-blue">Contact Us</h1>
      <p className="mt-4">
        Our FAQs page has helpful information for the most commonly asked
        questions, but for additional questions and support, please fill out the
        form below or{" "}
        <a
          href={`mailto:${EMAILS.CONTACT}`}
          className="text-theme-blue underline"
        >
          send us an email
        </a>
        .
      </p>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="mt-10 grid grid-cols-1 gap-x-12 gap-y-8 sm:grid-cols-2"
      >
        <div>
          <label htmlFor="name" className="mb-2 block text-xs opacity-75">
            Full Name
          </label>
          <Input
            {...register("name")}
            error={errors.name?.message}
            className="w-full"
          />
        </div>
        <div>
          <label htmlFor="Email" className="mb-2 block text-xs opacity-75">
            Email
          </label>
          <Input
            {...register("email")}
            error={errors.email?.message}
            className="w-full"
          />
        </div>
        <div>
          <label htmlFor="phone" className="mb-2 block text-xs opacity-75">
            Phone
          </label>
          <Input
            {...register("phone")}
            error={errors.phone?.message}
            className="w-full"
          />
        </div>
        <div>
          <label htmlFor="message" className="mb-2 block text-xs opacity-75">
            Message
          </label>
          <Textarea
            placeholder="Enter your message"
            {...register("message")}
            error={errors.message?.message}
            className="w-full"
            rows={6}
          />
        </div>

        <button
          type="submit"
          className="rounded bg-theme-blue px-4 py-3 text-white sm:col-start-2"
        >
          Contact Us
        </button>
      </form>
    </PublicPage>
  );
}
